import { connect, useDispatch } from 'react-redux';
import * as $ from 'jquery'
import { Preliminary, Binocular, Correction, PupillaryDistance, GlassView, Keratometry, ContactLens, External, Internal, Nct, Gat, VisualField, AdditionalTests, Procedure, ImpressionPlan, ContactLensPrescription, EyeGlassPrescription } from '../../../../components/authorised/exam/overview/index'
import { humanize, toggleId } from '../../../../itrust_common/components/HelperFunctions'
import { previousExamsLoad } from '../../../../itrust_common/redux/actions/exam/previousExamActions'
import { useEffect, useState } from 'react';
import Tonometry from '../../../../itrust_common/components/authorised/examFormPartial/internalExtenalTests/Tonometry';
import { examUpdate } from '../../../../redux/actions/exam/examActions'
import Alert from '../../../../itrust_common/components/Alert'
import OldValuesHeader from './OldValuesHeader'

const INCLUDE = ['binocular_balance', 'subjective', 'current_glasses', 'objective', 'cycloplegic', 'keratometry', 'current_lenses', 'internal', 'external', 'additional_tests', 'procedures', 'impressions', 'finalized_glasses', 'finalized_lenses']
const SELECTED_IMPORT_SECTIONS = ['procedure', 'impression']

function OldValuesWrapper(props) {
  const { overviewName, allExams, examId, patientId, previousExams, template, previousExam } = props
  const { preliminary_binocular_testing, refraction_contact_lens_exam, external_internal_exam, procedures_and_impressions, finalize_prescription, additional_tests } = template || {}
  const [selectedIds, setSelectedIds] = useState([])
  const [isModalExpanded, setIsModalExpanded] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    handlePreviousExamsLoad()
  }, [])

    // handlePreviousExamLoad(examId)
  //   handlePreviousExamsLoad()
  // }, [])

  // const handlePreviousExamLoad = (id) => {
  //   dispatch(previousExamLoad(id, { include: '*' }))
  //   setActiveExam(id)
  // }

  const handlePreviousExamsLoad = () => {
    dispatch(previousExamsLoad({ filter: { patient: patientId }, old_exam: true, include: INCLUDE }))
  }

  const handleIdsSelect = (ids, id) => {
    let idss = toggleId(ids, id)
    setSelectedIds(idss)
  }

  const overviewId = typeof overviewName === 'string' ? overviewName : overviewName?.id
  const usesSelectedImport = SELECTED_IMPORT_SECTIONS.includes(overviewId)

  const handleImportSelected = () => {
    if (!selectedIds.length) {
      Alert.warning('No record selected!, Please select some values and than import it.')
      return
    }

    const importKey = overviewId === 'procedure' ? 'import_procedure_ids' : 'import_impression_ids'
    dispatch(examUpdate({ id: examId, [importKey]: selectedIds }, { include: '*' }))
      .then(() => {
        setSelectedIds([])
        $(`#${overviewId}`).modal('toggle')
      })
  }

  const handleCloseModal = () => {
    setIsModalExpanded(false)
    setSelectedIds([])
    $(`#${overviewId}`).modal('hide')
  }

  const getCollapsedMaxWidth = (name) => {
    if (name === "external_exam" || name === "internal_exam")
      return '1140px'
    return '800px'
  }

  const getModalSize = (name) => {
    if (name === "external_exam" || name === "internal_exam")
      return "modal-xl"
    else return "modal-lg"
  }

  const useExpandedGrid = isModalExpanded

  const renderComponent = (name) => {
    switch (name) {
      case "preliminary":
        return <Preliminary previousExams={previousExams} fieldKey="priliminaries" template={preliminary_binocular_testing.priliminaries} overviewName={overviewName} examId={examId} />
      case "binocular":
        return <Binocular previousExams={previousExams} template={preliminary_binocular_testing.binocular} overviewName={overviewName} examId={examId} />
      case "visual_acuity_without_correction":
        return <Correction previousExams={previousExams} fieldKey="visual_acuity_without_correction" template={refraction_contact_lens_exam.visual_acuity.fields.without_correction} overviewName={overviewName} examId={examId} />
      case "visual_acuity_with_correction":
        return <Correction previousExams={previousExams} fieldKey="visual_acuity_with_correction" template={refraction_contact_lens_exam.visual_acuity.fields.with_correction} overviewName={overviewName} examId={examId} />
      case "current_glasses":
        return <GlassView previousExams={previousExams} fieldKey="current_glasses_attributes" template={refraction_contact_lens_exam.visual_acuity.fields.current_glass.tests[0]} overviewName="current_glasses" examId={examId} />
      case "pupillary_distance":
        return <PupillaryDistance previousExams={previousExams} template={refraction_contact_lens_exam.refraction.fields.pupillary_distance} overviewName={overviewName} examId={examId} />
      case "objective":
        return <GlassView previousExams={previousExams} fieldKey="objective_attributes" template={refraction_contact_lens_exam.refraction.fields.objective} overviewName={overviewName} examId={examId} />
      case "subjective":
        return <GlassView previousExams={previousExams} fieldKey="subjective_attributes" template={refraction_contact_lens_exam.refraction.fields.subjective} overviewName={overviewName} examId={examId} />
      case "cycloplegic":
        return <GlassView previousExams={previousExams} fieldKey="cycloplegic_attributes" template={refraction_contact_lens_exam.refraction.fields.cycloplegic} overviewName={overviewName} examId={examId} />
      case "binocular_balance":
        return <GlassView previousExams={previousExams} fieldKey="binocular_balance_attributes" template={refraction_contact_lens_exam.refraction.fields.binocular_balance} overviewName={overviewName} examId={examId} />
      case "keratometry":
        return <Keratometry name="keratometry_attributes" previousExams={previousExams} template={refraction_contact_lens_exam.contact_lens.fields.keratometry} overviewName={overviewName} examId={examId} />
      case "current_contact_lens":
        return (
          <ContactLens
            previousExams={previousExams}
            fieldKey="current_lenses_attributes"
            template={refraction_contact_lens_exam.contact_lens.fields.current_contact_lens.tests[0]}
            overviewName={overviewName}
            examId={examId}
          />
        )
      case "intraoffice_notes":
        return previousExams?.filter(item => item.id !== examId).map(prevExam =>
          <div className="col-12 border rounded mb-4 px-0" key={prevExam.id}>
            <div className="row mx-0">
              <OldValuesHeader prevExam={prevExam} overviewName={overviewName} examId={examId} />
              <p className="col-12 py-4">{prevExam.intraoffice_notes?.note}</p>
            </div>
          </div>
        )

      case "external_exam":
        return <External previousExams={previousExams} template={external_internal_exam.external_exam} overviewName={overviewName} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "gat":
        return <Gat previousExams={previousExams} template={external_internal_exam.gat} overviewName={overviewName} examId={examId} />
      case "nct":
        return <Nct previousExams={previousExams} template={external_internal_exam.nct} overviewName={overviewName} examId={examId} />
      case "tonometry":
        return <Tonometry fieldsValues={previousExam.tonometry} template={external_internal_exam} />
      case "visual_field":
        return <VisualField previousExams={previousExams} template={external_internal_exam.visual_field} overviewName={overviewName} examId={examId} />
      case "internal_exam":
        return <Internal previousExams={previousExams} template={external_internal_exam.internal_exam} overviewName={overviewName} examId={examId} />

      case "visual_summary_field":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "amsler_grid":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "external_imaging":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "punctal_plug":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "epilation":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "foreign_body_removal":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "skin_tag_removal":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "amniotic_membrane":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "pachymetry":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "inflamma_dry":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "tear_lab":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "internal_imaging":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "oct":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "topography":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />
      case "digital_retina_wellness_screening":
        return <AdditionalTests overviewName={overviewName} fieldsValues={previousExams} template={additional_tests} examId={examId} isExpandedGrid={useExpandedGrid} />

      case "procedure":
        return <Procedure overviewName={overviewName} handleIdsSelect={handleIdsSelect} selectedIds={selectedIds} previousExams={previousExams} fieldKey="procedures_attributes" examId={examId} />
      case "impression":
        return <ImpressionPlan overviewName={overviewName} handleIdsSelect={handleIdsSelect} selectedIds={selectedIds} previousExams={previousExams} fieldKey="impressions_attributes" examId={examId} />

      case "contact_lens_prescription":
        return <ContactLensPrescription previousExams={previousExams} fieldKey="finalized_lenses_attributes" template={finalize_prescription.contact_lens} overviewName={overviewName} examId={examId} />
      case "eye_glass_prescription":
        return <EyeGlassPrescription previousExams={previousExams} fieldKey="finalized_glasses_attributes" template={finalize_prescription.eye_glass} overviewName={overviewName} examId={examId} />
      default:
    }
  }

  return (
    <div className="inner-modal">
      <div className={`modal fade  ${(overviewName.id == "keratometry" || overviewName.id == "current_contact_lens") && "previous-value"}`} data-backdrop="static" id={overviewName.id} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div
          className={`modal-dialog ${isModalExpanded ? 'modal-xl' : getModalSize(overviewName.id)}`}
          style={{
            maxWidth: isModalExpanded ? '95vw' : getCollapsedMaxWidth(overviewName.id),
            width: isModalExpanded ? '95vw' : '100%',
            transition: 'max-width 0.4s ease-in-out, width 0.4s ease-in-out',
          }}
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <h5 className="modal-title" id="exampleModalLabel">Previous Test Values ({humanize(overviewName.id)})</h5>
              <div className="d-flex align-items-center">
                {usesSelectedImport && (
                  <button type="button" className="btn btn-outline-primary mr-4" onClick={handleImportSelected}>
                    Import Selected
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-outline-primary mr-4"
                  onClick={() => setIsModalExpanded(!isModalExpanded)}
                >
                  {isModalExpanded ? 'Compact View' : 'Expand View'}
                </button>
                {/* <button type="button" className="btn btn-outline-primary ml-4" onClick={() => {
                  setIsModalExpanded(false)
                  $(`#${overviewName.id}`).modal('hide')
                }}> */}
                <button type="button" className="btn btn-outline-primary ml-4" onClick={handleCloseModal}>
                  Close
                </button>
              </div>
            </div>
            <div className="modal-body">
              {/* <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <h6 className="mr-3 d-inline-block"> Accessing </h6>
                  <select className="custom-select" value={previousExam.id} onChange={(e) => handlePreviousExamLoad(e.target.value)}>
                    {allExams.map(exam =>
                      <option value={exam.id} key={exam.id}><DateFormatView date={exam.exam_date} /></option>
                    )}
                  </select>
                </div>
              </div> */}
              <div className="overflow-auto h-100">
                <div
                  className={useExpandedGrid ? '' : 'row mx-0'}
                  style={useExpandedGrid ? { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '1rem' } : undefined}
                >
                  {(overviewName.id && previousExams.length > 0) && renderComponent(overviewName.id)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { exam, previousExam } = state
  return {
    allExams: exam.exam.all_exams,
    overviewName: previousExam.editing,
    previousExam: previousExam.previousExam || {},
    previousExams: previousExam.previousExams || []
  }
}
export default connect(mapStateToProps)(OldValuesWrapper);